import dayjs from "../../../utils/date-utils";
import ja from "dayjs/locale/ja";
import isBetween from "dayjs/plugin/isBetween";
dayjs.locale(ja);
dayjs.extend(isBetween);

const userAuditProvideStartAt = dayjs("2023-06-08", "YYYY-MM-DD");

export const userAuditLogOldestAvailableDate = (): Date => {
  const oldestDate = dayjs().add(-90, "day");
  if (oldestDate.isBefore(userAuditProvideStartAt)) {
    return userAuditProvideStartAt.toDate();
  }
  return oldestDate.toDate();
};
